module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _vm._v("THINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Things are exactly what they are and as they are; that is, they possess being-in-itself"), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1-1"
    }
  }, [_vm._v("*")]), _vm._v(" and are in themselves. They exist in pure positivity but are also purely contingent—unfounded and without the possibility of having a foundation. They simply "), _c('i', [_vm._v("are")]), _vm._v(". Their being is absolute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A thing unsatisfied with its existence and desirous of establishing for itself a foundation must become aware of itself through reflection. It must achieve separation from itself. Obviously, however, it can effect a separation only by splitting in two and keeping its parts distinct. This it accomplishes through the instrumentality of nothingness. It follows that a thing in order to be able to reflect on itself and provide for itself a foundation must contain nothingness. Through pure positivity it is transformed into a negativity, into something that contains nothingness. It is no longer in itself, no longer coincident with itself, but only present with respect to itself. It is no longer "), _c('i', [_vm._v("in")]), _vm._v(" itself "), _c('i', [_vm._v("but")]), _vm._v(" for itself. It is no longer a thing, an "), _c('i', [_vm._v("in-itself;")]), _vm._v(" it is a "), _c('i', [_vm._v("for-itself")]), _vm._v(". And the for-itself possesses consciousness; this means that it possesses at the same time freedom and can select ends. Because it selects and pursues ends, the for-itself acquires individuality. It becomes a man. Choosing and pusuing ends is coincident with the emergence of the for-itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Things have qualities. For us the most important are their coefficients of hostility and their utility. These qualities are obvious if I consider things from the standpoint of the end selected. For depending on whether things hinder or facilitate my reaching the end, I become aware of their coefficients of hostility or of their utility. “The for-itself discovers itself as engaged in being (that is, in being-in-itself), hemmed in by being, threatened by being; it discovers the state of things which surrounds it as the cause for a reaction of defense or attack. But it can make this discovery only because it freely posits the end in relation to which the state of things is makes threatening or favorable.”"), _c('a', {
    attrs: {
      "id": "ch01fn1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch01fn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Before the for-itself makes its choice, things seem indifferent, and the for-itself feels lost in their indifference; it feels neglected and chooses an end in order to compel things to unveil their being, to turn toward it their faces. Along with their being, things naturally unveil also their otherness, that is, the fact that they are not the for-itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are separated from things by nothing "), _c('i', [_vm._v("except by our freedom")]), _vm._v("; it is our freedom which is responsible for the fact that "), _c('i', [_vm._v("there are")]), _vm._v(" things with all their indifference, their unpredictability, and their adversity, and for the fact that we are inevitably separated from them; for it is on the ground of nihilation that they appear and that they are revealed as bound one to another.”"), _c('a', {
    attrs: {
      "id": "ch01fn2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch01fn2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" By nihilation is meant our ability to refuse to accept things as they are and to transform them instead into tools which will help us to attain our goal, acquire knowledge, etc. Our freedom to nihilate, however, “adds "), _c('i', [_vm._v("nothing")]), _vm._v(" to things.”"), _c('a', {
    attrs: {
      "id": "ch01fn3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch01fn3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-left"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "fn1-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("*")]), _vm._v("Words coined by Sartre or used by him in a special sense are listed in the “Glossary of Special Terms.” Tr.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8813e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 72
// module chunks = 0